import { ConfigProvider } from "antd";
import { medSyncTheme } from "@/shared/theme/antdTheme";
import { AppRouter } from "./router";

export default function App() {
  return (
    <ConfigProvider theme={medSyncTheme} wave={{ disabled: true }}>
      <AppRouter />
    </ConfigProvider>
  );
}
